import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { SaveCancelButtonsComponent } from "../save-cancel-buttons/save-cancel-buttons.component";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-reset-password-dialog",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatInputModule,
    SaveCancelButtonsComponent,
  ],
  template: `
    <h2 mat-dialog-title class="qundis-section-heading-h2">
      Password zurücksetzen
    </h2>
    <mat-dialog-content>
      <p>
        Vergeben Sie ein neues Passwort. <br />
        Der Benutzer wird beim ersten Login aufgefordert, dieses Passwort zu
        ändern.
      </p>
      <mat-form-field [formGroup]="resetPassword">
        <mat-label>Neues Passwort</mat-label>
        <input matInput type="text" minlength="6" formControlName="password" />
      </mat-form-field>
      <app-save-cancel-buttons
        (cancelEvent)="dialogRef.close()"
        (saveEvent)="updatePassword()"
      />
    </mat-dialog-content>
  `,
  styles: [],
})
export class ResetPasswordDialogComponent {
  formBuilder = inject(FormBuilder);
  apiService = inject(ApiService);
  resetPassword: FormGroup = this.formBuilder.group({
    password: ["", Validators.required],
  });
  readonly dialogRef = inject(MatDialogRef<ResetPasswordDialogComponent>);

  updatePassword() {
    if (this.resetPassword.valid) {
      this.dialogRef.close({
        newPassword: this.resetPassword.get("password")?.value,
      });
    }
  }
}
